import { render, staticRenderFns } from "./ReactionContextMenu.vue?vue&type=template&id=4c1f0872&scoped=true"
import script from "./ReactionContextMenu.vue?vue&type=script&lang=js"
export * from "./ReactionContextMenu.vue?vue&type=script&lang=js"
import style0 from "./ReactionContextMenu.vue?vue&type=style&index=0&id=4c1f0872&prod&lang=scss"
import style1 from "./ReactionContextMenu.vue?vue&type=style&index=1&id=4c1f0872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f0872",
  null
  
)

export default component.exports